import React, { useState } from "react";
import axios from "axios";
import { Table, Input, Button, Row, Col, Spinner } from "reactstrap";
import Moment from "react-moment";
import moment from "moment";
import { Cookies } from "react-cookie";
import { orderStatus } from "../../utils/ConvertWord";

const cookies = new Cookies();

function OrderSearch() {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const handleSearch = async () => {
    if (!searchKeyword.trim()) {
      alert("검색어를 입력해주세요.");
      return;
    }

    setIsLoading(true);
    setHasSearched(true);

    try {
      const encodedWholesaler = cookies.get("info").profile;
      const encodedKeyword = searchKeyword.trim();

      const response = await axios.get(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/search/order`,
        {
          params: {
            keyword: encodedKeyword,
            wholesaler: encodedWholesaler,
          },
          headers: {
            Authorization: cookies.get("info").token,
          },
        }
      );

      if (response.data.result === "success") {
        setSearchResults(response.data.data);
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      console.error("검색 중 오류 발생:", error);
      setSearchResults([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const convertPriceFormat = (productCode, unitPrice, qauntity) => {
    let resValue = null;

    // productCode가 null이거나 undefined인 경우 예외처리
    if (!productCode) {
      return "미정";
    }

    let pcode = productCode.toUpperCase();

    // 예외처리 코드 : BRING, CHEMIST, MART, PROMO, SPECIAL, 공백
    if (pcode === "BRING" || pcode === "PROMO") {
      resValue = "$0";
    } else if (
      pcode === "CHEMIST" ||
      pcode === "MART" ||
      pcode === "SPECIAL" ||
      pcode === ""
    ) {
      resValue = "미정";
    } else {
      resValue =
        "$" +
        parseFloat(unitPrice * qauntity)
          .toFixed(2)
          .toString();
    }

    return resValue;
  };

  const genAmount = (items, delivery_fee) => {
    let amount = 0.0;

    items.map((item) => {
      let price = convertPriceFormat(
        item.productCode,
        item.unitPrice,
        item.qauntity
      ).replace("$", "");
      if (!isNaN(price)) {
        amount += parseFloat(price);
      }
    });
    // 배송료 추가
    amount += parseFloat(delivery_fee || 0);

    return amount.toFixed(2);
  };

  return (
    <div className="border p-3 bg-light">
      <Row className="mb-3 justify-content-center">
        <Col md={4}>
          <Input
            type="text"
            placeholder="고객명, 모바일번호, 통관부호, 운송장번호로 검색"
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </Col>
        <Col md={2}>
          <Button color="primary" onClick={handleSearch} block>
            검색
          </Button>
        </Col>
      </Row>

      {isLoading ? (
        <div className="text-center p-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">검색 중...</span>
          </Spinner>
        </div>
      ) : hasSearched ? (
        searchResults.length > 0 ? (
          <div className="table-responsive">
            <Table hover bordered>
              <thead>
                <tr className="table-primary">
                  <th className="text-center p-2 border">고객명</th>
                  <th className="text-center p-2 border">운송장번호</th>
                  <th className="text-center p-2 border">무게(kg)</th>
                  <th className="text-center p-2 border">주문상태</th>
                  <th className="text-center p-2 border">모바일번호</th>
                  <th className="text-center p-2 border">통관부호</th>
                  <th className="text-center p-2 border">주문상품</th>
                  <th className="text-center p-2 border">총액</th>
                  <th className="text-center p-2 border">등록일</th>
                  <th className="text-center p-2 border">출고일</th>
                </tr>
              </thead>
              <tbody>
                {searchResults.map((order, idx) => (
                  <tr key={order.order_index || idx}>
                    <td className="text-center">{order.customer_name}</td>
                    <td className="text-center">
                      {order.hawb ? (
                        <a
                          href={
                            "https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=" +
                            order.hawb
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {order.hawb}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-center">{order.weight}</td>

                    <td className="text-center">
                      {orderStatus(order.order_status)}
                    </td>

                    <td className="text-center">{order.customer_mobile}</td>
                    <td className="text-center">{order.pcc}</td>

                    <td style={{ padding: "0px" }}>
                      <Table bordered style={{ margin: "0px", width: "100%" }}>
                        <tbody>
                          {order.order_product &&
                            order.order_product.map((item, index) => (
                              <tr key={index}>
                                <td
                                  className="text-center"
                                  style={{ width: "70px" }}
                                >
                                  {item.productCode}
                                </td>
                                <td className="cell">{item.productName}</td>
                                <td
                                  style={{ width: "60px" }}
                                  className="text-center"
                                >
                                  {item.qauntity}개
                                </td>
                                <td
                                  style={{ width: "70px" }}
                                  className="text-center"
                                >
                                  {convertPriceFormat(
                                    item.productCode,
                                    item.unitPrice,
                                    item.qauntity
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </td>
                    <td className="text-center">
                      ${genAmount(order.order_product, order.delivery_fee)}
                    </td>
                    <td className="text-center">
                      {order.created_at &&
                      moment(order.created_at).isValid() ? (
                        <Moment format="YYYY-MM-DD">{order.created_at}</Moment>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-center">
                      {order.delivery_at &&
                      moment(order.delivery_at).isValid() ? (
                        <Moment format="YYYY-MM-DD">{order.delivery_at}</Moment>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="text-center p-5">
            <p>검색 결과가 없습니다.</p>
          </div>
        )
      ) : (
        <div className="text-center p-5 text-muted">
          검색어를 입력하고 검색 버튼을 클릭하세요.
        </div>
      )}
    </div>
  );
}

export default OrderSearch;
